import { Slide } from "@jelly/lesson";
import theory from "../../theory";

const principle: Slide = {
  description:
    "A method for estimating the Thiele and Small parameters of an electrodynamic loudspeaker is presented below. Navigate with the arrows to discover it!",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1, 4],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "Summary",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "14px",
                    lineHeight: "22px",
                    fontWeight: 800,
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: `<ol>
                  <li>The measurement methods presented here allow to estimate the parameters of Thiele and Small.
                  <li>The measured values are close to the values provided by the manufacturer.
                  <li>Deviations of the order of 10% are typical and may be due to changes in the manufacturer’s suppliers, variations due to assembly, variations inherent in mass production, lack of break-in period, etc.
                  <li>Professional software programs exist that include simultaneous measurement of electrical impedance and diaphragm velocity to obtain more accurate results.
                  </ol>`,
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "14px",
                    lineHeight: "20px",
                    fontWeight: 400,
                  },
                },
              },
              styles: {
                alignItems: "flex-start",
                padding: "0 18.1%",
              },
            },
          },
        ],
        [],
      ],
    },
  },
};

export default principle;
